var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    { attrs: { loading: _vm.loading } },
    [
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "justify-content": "space-between",
            "align-items": "center",
          },
          attrs: { slot: "header" },
          slot: "header",
        },
        [
          _c("div", [_vm._v("基本信息")]),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: {
                click: function ($event) {
                  _vm.addNewModal = true
                },
              },
            },
            [_vm._v("编辑详情")]
          ),
        ],
        1
      ),
      _c(
        "el-form",
        {
          ref: "detailModalForm",
          staticClass: "detailDialog",
          attrs: {
            "label-position": "left",
            "label-suffix": "：",
            "label-width": "100px",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { prop: "name", label: _vm.$t("supplier::table_name") } },
            [_vm._v(" " + _vm._s(_vm.detailModalForm.name) + " ")]
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                prop: "contacts",
                label: _vm.$t("supplier::table_staff"),
              },
            },
            [_vm._v(" " + _vm._s(_vm.detailModalForm.contacts) + " ")]
          ),
          _c(
            "el-form-item",
            {
              attrs: { prop: "phone", label: _vm.$t("supplier::table_phone") },
            },
            [_vm._v(" " + _vm._s(_vm.detailModalForm.phone) + " ")]
          ),
          _c(
            "el-form-item",
            { attrs: { prop: "area", label: _vm.$t("supplier::form_area") } },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.detailModalForm.province) +
                  _vm._s(_vm.detailModalForm.city) +
                  _vm._s(_vm.detailModalForm.area) +
                  " "
              ),
            ]
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                prop: "address",
                label: _vm.$t("supplier::form_address"),
              },
            },
            [_vm._v(" " + _vm._s(_vm.detailModalForm.address) + " ")]
          ),
          _c(
            "el-form-item",
            { attrs: { prop: "email", label: _vm.$t("supplier::form_email") } },
            [_vm._v(" " + _vm._s(_vm.detailModalForm.email) + " ")]
          ),
        ],
        1
      ),
      _vm.addNewModal
        ? [
            _c("editDialog", {
              attrs: {
                id: _vm.id,
                isNew: false,
                formData: _vm.detailModalForm,
              },
              on: { getListData: _vm.getDetail },
              model: {
                value: _vm.addNewModal,
                callback: function ($$v) {
                  _vm.addNewModal = $$v
                },
                expression: "addNewModal",
              },
            }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }